// Shared low-poly material palette for 3D models. Muted, faceted, sits alongside
// the terrain colours. Owner colour is layered on top as roofs/banners/tunics.

export const MAT = {
  wood: '#8a6a43',
  woodDk: '#6d5334',
  /** Fresh-carved pale wood: wooden TOOL HEADS — must read clearly against the
   *  darker haft and never grey like stone/metal. */
  woodPale: '#b98e55',
  timber: '#72513b',
  thatch: '#d3ad61',
  thatchDk: '#9c8443',
  plaster: '#eee0bc',
  plasterDk: '#c9b48a',
  stone: '#a6a59b',
  stoneDk: '#6f6b66',
  slate: '#536e79',
  dirt: '#7c6a4d',
  soil: '#5f4f38',
  leaf: '#3f7a3a',
  leafDk: '#316030',
  cloth: '#d8cdb4',
  metal: '#b9c0c6',
  metalDk: '#585d63',
  skin: '#d7a074',
  crop: '#c9b64d',
  water: '#2e6f9f',
  coal: '#3a3a40',
  gold: '#e6b93f',
  ironOre: '#7d8188',
} as const

/** Tiny deterministic RNG (mulberry32) so the same seed gives the same model. */
export function rng3d(seed: number): () => number {
  let a = (seed | 0) + 0x6d2b79f5
  return () => {
    a |= 0; a = (a + 0x6d2b79f5) | 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
